import { Chip, Grid } from '@mui/material';
import { UniFunc } from '../../dao/UniFunc';
import { new_ErrorAlert } from '../../export_spwk/ExportManager';
import { SpwkToHisInfo } from './SpwkToHisInfo'

type Props = {
  CurrInfo: SpwkToHisInfo | undefined;
  CacheUniFuncList: UniFunc[];

  /** 當前 選中的 的 UniFunc */
  CurrUniFunc: UniFunc | null;

  OnUniFuncSelected: (sel_uni_func: UniFunc) => void;
}

const UcSpwkPills = ({ CurrInfo, CacheUniFuncList,
  CurrUniFunc, OnUniFuncSelected, ...props }: Props) => {

  // 先取得特作的 guids
  let spwk_func_guids = CurrInfo?.Ans.getSpwkFuncGuidList() ?? [];

  //#region 找出此 Ans 用到的 FuncList
  let ans_func_list = [];

  if (CacheUniFuncList != null && CacheUniFuncList.length !== 0) {
    for (const func_guid of spwk_func_guids) {
      const find_func = CacheUniFuncList.find(x => x.guid === func_guid);
      if (find_func == null) {
        throw new_ErrorAlert("4643531645 應該要對應到 UniFunc !!!" + func_guid);
      }
      if (find_func != null) {
        ans_func_list.push(find_func);
      }

    }
  }

  //#endregion

  return (
    <Grid container spacing={1} padding={1}>
      {
        ans_func_list.map(x => {
          return <Grid item key={x.guid}>{render_Pill(x)}</Grid>;
        })
      }
    </Grid>
  );

  function render_Pill(x: UniFunc): JSX.Element {
    return <Chip key={x.guid} label={x.func_code} onClick={() => { btn_Pill_Click(x); }} color={(x.guid === CurrUniFunc?.guid ? "primary" : undefined)} />;
  }

  function btn_Pill_Click(x: UniFunc) {
    OnUniFuncSelected(x);
  }
}

export default UcSpwkPills